import React from "react";

const sizes = {
  "5xl": "text-[35px] font-normal leading-[55px]",
  xs: "text-[13px] font-medium leading-[189.5%]",
  lg: "text-[17px] font-normal",
  s: "text-sm font-normal leading-[175.4%]",
  "2xl": "text-[19px] font-normal leading-[23px]",
  "3xl": "text-xl font-normal leading-[25px]",
  "4xl": "text-3xl font-normal leading-[189.5%]",
  xl: "text-lg font-normal leading-[22px]",
  md: "text-base font-normal leading-[236.3%]",
};

const Text = ({ children, className = "", as, size = "s", ...restProps }) => {
  const Component = as || "p";

  return (
    <Component className={`text-blue_gray-400 font-inter ${className} ${sizes[size]}`} {...restProps}>
      {children}
    </Component>
  );
};

export { Text };
